export default __webpack_public_path__ + "static/media/song3_img.6654d28c.jpg";